import { Component, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { AsyncPipe, NgTemplateOutlet, PlatformLocation } from '@angular/common';
import { KompaktdarstellungTemplateComponent } from '../kompakt-darstellung-template.component';
import { RechtMasterListEntry, RechtMasterListEntryMeta, RechtVersionListEntry, RechtVersionListEntryMeta } from '../../../core/gb-api';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { ComponentLocationStrategy } from '../../services/location-strategy/component-location-strategy';
import { TranslatePipe } from '@ngx-translate/core';
import { BetragPipe } from '../../pipes/simple/betrag.pipe';
import { DatumPipe } from '../../pipes/simple/datum.pipe';
import { FormatRechteIdPipe } from '../../pipes/format/format-rechte-id.pipe';
import { TranslateNamePipe } from '../../pipes/simple/translate-name.pipe';

@Component({
  selector: 'cap-kompakt-standardrecht-beschreibung',
  templateUrl: './kompakt-standard-recht-beschreibung.component.html',
  preserveWhitespaces: false,
  imports: [NgTemplateOutlet, TranslatePipe, BetragPipe, DatumPipe, FormatRechteIdPipe, TranslateNamePipe, AsyncPipe]
})
export class KompaktStandardRechtBeschreibungComponent extends KompaktdarstellungTemplateComponent implements OnInit, OnChanges {
  @Input() item: RechtMasterListEntry | RechtMasterListEntryMeta;
  version: RechtVersionListEntry | RechtVersionListEntryMeta;

  @ViewChild('default', { static: true }) defaultTemplate: TemplateRef<any>;
  @ViewChild('rechteId', { static: true }) rechteIdTemplate: TemplateRef<any>;

  constructor(
    formatService: FormatConfigService,
    location: PlatformLocation,
    locationStrategy: ComponentLocationStrategy,
    protected appformatConfigService: FormatConfigService
  ) {
    super(formatService, 'STANDARDRECHT', location, locationStrategy);
    keysToTranslate<string>([
      'DIENSTBARKEIT_KURZ',
      'ANMERKUNG_KURZ',
      'VORMERKUNG_KURZ',
      'GRUNDLAST_KURZ',
      'PFANDRECHT_KURZ',
      'SDR_DIENSTBARKEIT_KURZ'
    ]);
  }

  registerTemplates() {
    this.bindTemplates(this.defaultTemplate, 'STANDARDRECHT_TYP00');
    this.bindTemplates(this.rechteIdTemplate, 'STANDARDRECHT_TYP01');
  }

  getAbkuerzungKey(input: string) {
    return input + '_KURZ';
  }

  getDefaultTemplate(): TemplateRef<any> {
    return this.defaultTemplate;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.version = this.item.version;
  }
}
